import { render } from "./aio-login-templates.vue?vue&type=template&id=926dae68&scoped=true"
import script from "./aio-login-templates.vue?vue&type=script&lang=js"
export * from "./aio-login-templates.vue?vue&type=script&lang=js"

import "./aio-login-templates.vue?vue&type=style&index=0&id=926dae68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926dae68"]])

export default __exports__